import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import gridLabels from "../Labels/GridLabels";
import DATA_QUERY_COLUMNS from "./DataQueryTableColumn";
import DataQueryModalEditor from "./DataQueryModalEditor";
import { setLoading } from "../../store/loading";
import { Box } from "@mui/system";
import RowButtonIcon from "../UI/RowButtonIcon";
import EditIcon from "@mui/icons-material/Edit";
import ButtonAdd from "../UI/ButtonAdd";
import BoxRowButtonsIcon from "../UI/BoxRowButtonsIcon";
import DialogDelete from "../UI/DialogDelete";
import SearchInput from "../UI/SearchInput";
import { DeleteOutline } from "@mui/icons-material";
import useFormsFormulaStore from "../../store/zustandStore/formsFormulaZs";

const DataQuery = () => {
  const {
    fetchFormsFormulaZs,
    formsFormulaZs,
    getEvaluateFormFormulaZs,
    evaluateFormFormulaZs,
    deleteFormFormulaZs,
    pageSizeFormulaZs,
    filterFormulaZs,
    currentPageFormulaZs,
    total,
    setPageFormulaZs,
    totalPagesFormulaZs,
  } = useFormsFormulaStore();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [stateDialogDelete, setStateDialogDelete] = React.useState(false);
  const [isStatusNew, setIsStatusNew] = React.useState(false);
  const [njesi, setNjesi] = React.useState({});
  const [dataColumns, setDataColumns] = React.useState(DATA_QUERY_COLUMNS);

  const initialNjesi = {
    id: "",
    name: "",
  };

  const handleChangePage = (event, newPage) => {
    setPageFormulaZs(event);
  };

  React.useEffect(() => {
    fetchFormsFormulaZs();
  }, []);

  const [filterModel, setFilterModel] = React.useState({
    items: [
      {
        columnField: "",
        operatorValue: ">",
        value: "",
      },
    ],
  });

  const currentlySelected = (e) => {
    setIsStatusNew(false);
    setNjesi(e.row);
    setOpen(true);
  };

  const addNew = () => {
    setIsStatusNew(true);
    setNjesi(initialNjesi);
    setOpen(true);
  };

  const handleCloseDialogDelete = (e) => {
    setStateDialogDelete(false);
  };

  const handleDeleteDataQuery = (e) => {
    deleteFormFormulaZs(njesi);
    setStateDialogDelete(false);
  };

  function CustomToolbar() {
    return (
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            py: "18px",
            px: "9px",
            alignItems: "center",
            bgcolor: "transparent",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              textAlign: "center",
              direction: "column",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* <SearchInput
              onChange={searchItems}
              inputRef={searchState}
              defaultValue={searchState.current.value}
            ></SearchInput> */}
          </Box>
          <ButtonAdd onClick={addNew} />
        </Box>
      </Box>
    );
  }
  return (
    <div style={{ height: 700, width: "100%" }}>
      <DataGrid
        labelRowsPerPage="Artikuj per faqe"
        disableSelectionOnClick
        onRowDoubleClick={currentlySelected}
        columns={[
          ...dataColumns,
          {
            headerName: "",
            overflow: "hidden",
            field: "actions",
            editable: false,
            flex: 1,
            justifyContent: "flex-end",
            disableClickEventBubbling: true,
            align: "right",
            background: "red",
            headers: false,
            renderHeader: () => {},
            renderCell: (params) => (
              <BoxRowButtonsIcon>
                <RowButtonIcon
                  onClick={(event) => {
                    currentlySelected(params);
                  }}
                >
                  <EditIcon />
                </RowButtonIcon>
                <RowButtonIcon
                  onClick={(event) => {
                    // currentlySelected(params);
                    setNjesi(params?.row);
                    setStateDialogDelete(true);
                  }}
                >
                  <DeleteOutline color="error" />
                </RowButtonIcon>
              </BoxRowButtonsIcon>
            ),
          },
        ]}
        rows={filterFormulaZs ? filterFormulaZs : []}
        density="comfortable"
        editMode="row"
        disableColumnMenu
        localeText={gridLabels}
        componentsProps={{
          pagination: {
            labelRowsPerPage: "Rreshta për Faqe",
            showLastButton: true,
            showFirstButton: true,
          },
        }}
        components={{
          Toolbar: CustomToolbar,
        }}
        filterModel={filterModel}
        onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
        page={currentPageFormulaZs}
        onPageChange={handleChangePage}
        count={totalPagesFormulaZs}
        rowCount={total}
        pageSize={pageSizeFormulaZs}
        pagination
        paginationMode="server"
      />
      <DialogDelete
        open={stateDialogDelete}
        disagreedelete={handleCloseDialogDelete}
        agreedelete={handleDeleteDataQuery}
        description="Jeni të sigurt që doni ta fshini këtë Kërkesë? "
      />
      <DataQueryModalEditor
        open={open}
        onClose={handleClose}
        formname="Kërkesë të dhënash"
        isstatusnew={isStatusNew ? 1 : 0}
        data={njesi}
      ></DataQueryModalEditor>
    </div>
  );
};

export default DataQuery;
